import { useMemo, useState } from "react"
import { useNavigate, useLocation, useParams } from "react-router-dom"
import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { BreadCrumb, NewCard } from "../../../../../../components"
import { NavigatioStateType } from "../../../../../../utils/enums/navigatetionState"
import { GoBackToList, Step1, Step2 } from "./Components"
import { useTranslation } from "react-i18next"
import { FormProvider } from "./Context"

export const FormPreventive = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation()
  const [currentStep, setCurrentStep] = useState(1);
  const { id } = useParams()

  const listBreadCrumb = useMemo(() => {
    if (location.state?.type == NavigatioStateType.SCHEDULE) {
      return [
        {
          id: 'schedule',
          label: 'schedule',
          navigate: () => { navigate(`/dashboard/calendar`) }
        },
        {
          id: 'scheduleList',
          label: 'scheduleList',
          navigate: () => { navigate(`/dashboard/calendar/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'reportFolioList',
          navigate: () => { navigate(`/dashboard/calendar/report-folio-list${location.search}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'NewRequest',
          navigate: () => { }
        },
      ]
    }
    if (location.state?.type == NavigatioStateType.USER_SCHEDULE) {
      return [
        {
          id: 'schedule',
          label: 'schedule-user',
          navigate: () => { navigate(`/dashboard/schedule-user`) }
        },
        {
          id: 'scheduleList',
          label: 'scheduleDetail',
          navigate: () => { navigate(`/dashboard/schedule-user/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'reportFolioList',
          navigate: () => { navigate(`/dashboard/schedule-user/report-folio-list${location.search}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'NewRequest',
          navigate: () => { }
        },
      ]
    }
    return undefined
  }, [])

  const styles = useStyles();

  const handleNextStep = () => {
    setCurrentStep(2);
  };

  // Function to go back to previous step
  const handlePreviousStep = () => {
    setCurrentStep(1);
  };

  return (
    <FormProvider>
      <Box sx={styles.container}>
        <BreadCrumb
          removeBreadcrumb={['report-folio', 'calendar', 'schedule-user']}
          replaceLabels={{
            dashboard: 'maintenanceRequest',
            preventivo: 'NewRequest'
          }}
          breadList={listBreadCrumb}
        />

        <NewCard>
          <Box sx={{ p: 3 }}>
            <GoBackToList exit />
            <Typography sx={styles.title} mb={5}>{!id ? t("reportFolio.forms.preventiveMaintenance") : t("reportFolio.forms.preventiveMaintenanceEdit")}</Typography>
            {/* STEP 1 */}
            <Box mt={4}>
              {currentStep === 1 && (
                <Step1 onContinue={handleNextStep} />
              )}

              {currentStep === 2 && (
                <Step2 onBack={handlePreviousStep} />
              )}


            </Box>
          </Box>

        </NewCard>
      </Box>
    </FormProvider>

  )
}